/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Toggle from 'app/components/common/ToggleControl.jsx';
import ShortenerDetailDefault from 'app/components/ShortenerLists/ShortenerDetailDefault.jsx';
import ShortenerDetailBitly from 'app/components/ShortenerLists/ShortenerDetailBitly.jsx';
import ShortenerDetailCustom from 'app/components/ShortenerLists/ShortenerDetailCustom.jsx';
import ShortenerDetailDomain from 'app/components/ShortenerLists/ShortenerDetailDomain.jsx';
import ShortenerDetailWrapper from 'app/mixins/ShortenerDetailWrapper.jsx';
import MessageModule from 'app/mixins/MessageModule.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class ShortenerListDetail extends React.Component {
    constructor(props) {
        super(props);

        this.deleteItem = this.deleteItem.bind(this);
        this.updateItem = this.updateItem.bind(this);
        this.testShortener = this.testShortener.bind(this);

    }

    deleteItem(e) {
        e.preventDefault();
        this.props.deleteMessage(['SHORTENER_UPDATE', 'SHORTENER_TEST', 'DOMAIN_UPDATE']);
        this.props.deleteItem(this.props.type, this.props.detail.id);
    }

    updateItem(item) {
        let update = this.props.data,
            shortenerUpdater = this.props.updateShortener;

        if (this.props.updatedCreds) {
            update.credID = this.props.updatedCreds;
        }

        this.props.deleteMessage(['SHORTENER_UPDATE', 'SHORTENER_TEST', 'DOMAIN_UPDATE']);

        if (this.props.type === 'shortener') {
            let id = parseInt(this.props.data.id, 10);
            if (id === 0 || id === 1) {
                // Synthetic placeholders carry no DB row; toggle clicks propagate the id
                // straight to the server as the new pub_defaultSaID.
                if (this.props.data.default) {
                    this.props.setAsDefault(this.props.type, id);
                }
                if (this.props.data.applyRoutes) {
                    this.props.applyToAll(this.props.type, id, 'route');
                }
                if (this.props.data.applyOutputs) {
                    this.props.applyToAll(this.props.type, id, 'output');
                }
            } else {
                this.props.deleteApiError(['SHORTENER_UPDATE', 'SHORTENER_APPLY']);
                shortenerUpdater.apply(this, [update]);
            }
        } else if (this.props.type === 'domain') {
            this.props.deleteApiError(['DOMAIN_UPDATE', 'DOMAIN_APPLY']);
            this.props.updateDomain(update);
        }

        // reset the apply toggles
        update.applyRoutes = 0;
        update.applyOutputs = 0;

        this.setState({
            data: update,
            errors: {}
        });
    }

    testShortener(e) {

        let id = e.currentTarget.dataset.id;

        e.preventDefault();
        this.props.deleteMessage(['SHORTENER_TEST']);
        this.props.testShortener(id);

    }

    render() {
        let constants = this.props.app.config.constants,
            statusBlock = null,
            defaultActive = this.props.detail.default && parseInt(this.props.detail.default, 10) ? true : false,
            thingLabel = this.props.type === 'shortener' ? 'Shortener' : 'Domain',
            detailControls = null,
            applyButtons = null,
            serviceOptions = null,
            panelContent = null,
            Panel = null,
            messages = [],
            errList = null,
            errors = null,
            buttons = {
                delete: null,
                reconnect: null,
                test: null,
                save: null
            };

        // can only delete user generated shorteners/domains
        if (parseInt(this.props.detail.id, 10) > 1) {
            buttons.delete = (
                <div className="detail-toggle">
                    <div className="detail-button" onClick={this.deleteItem} data-id={this.props.detail.id} role="button" aria-label={`Delete ${thingLabel}`}>
                        <div className="button-label">
                            Delete {thingLabel}
                        </div>
                    </div>
                </div>
            );
        }

        if (this.props.detail.ssID) {
            if (this.props.detail.ssID == constants.SHORTEN_SVC_BITLY
                || this.props.detail.ssID == constants.SHORTEN_SVC_CUSTOM
            ) {
                buttons.reconnect = (
                    <div className="detail-button" onClick={this.props.reauthHandler} data-id={this.props.detail.id} data-serviceid={this.props.detail.ssID} role="button" aria-label="reconnect">
                        <div className="button-icon">
                            <i className="fa fa-refresh"></i>
                        </div>
                        <div className="button-label">
                            Reconnect
                        </div>
                    </div>
                );
            }
        }

        if ((this.props.detail.ssID !== undefined && parseInt(this.props.detail.ssID, 10) > 1) && this.props.updatedCreds === "") {
            buttons.test = (
                <div className="detail-button" onClick={this.testShortener} data-id={this.props.detail.id} role="button" aria-label="test shortener">
                    <div className="button-icon">
                        <i className="fa fa-bolt"></i>
                    </div>
                    <div className="button-label">
                        Test Shortener
                    </div>
                </div>
            );
        }

        buttons.save = (
            <div className="detail-button" onClick={this.updateItem} data-id={this.props.detail.id} role="button" aria-label="save">
                <div className="button-label">
                    Save
                </div>
            </div>
        );

        detailControls = (
            <div>
                <Breakpoint desktop only>
                    <div className="detail-controls">
                        {buttons.delete}
                        <div className="detail-buttons">
                            {buttons.save}
                            {buttons.test}
                            {buttons.reconnect}
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className="detail-controls mobile">
						<div className="detail-control-row">
                            {buttons.save}
                            {buttons.delete}
                        </div>
                        {(buttons.test !== null || buttons.reconnect !== null) ? (
                            <div className="detail-control-row">
                                {buttons.test}
                                {buttons.reconnect}
                            </div>
                        ) : null}
                    </div>
                </Breakpoint>
            </div>
        );

        if (this.props.detail.id || this.props.detail.id === 0) {
            messages = this.props.getAppMessages(['SHORTENER_UPDATE', 'DOMAIN_UPDATE', 'SHORTENER_TEST']);
            if (messages.length) {
                statusBlock = (
                    <MessageModule
                        app={this.props.app}
                        keys={['SHORTENER_UPDATE', 'DOMAIN_UPDATE', 'SHORTENER_TEST']}
                        render={(state) => {
                            return (
                                <div className="detail-status info">
                                    {state.messages.map((message) => {
                                        return (
                                            <div key={message.id}>
                                                {message.message}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        }}/>
                );
            }

            if (parseInt(this.props.detail.errCount, 10) > 0) {
                if (_.isArray(this.props.detail.errList) && this.props.detail.errList.length) {
                    errList = this.props.detail.errList;
                    errList = (errList.length <= 5) ? errList : errList.slice(0, 5);
                    errors = (
                        <ul className="error-list">
                            {this.props.detail.errList.map(function(error){
                                return (
                                    <li className="error-list-item">
                                        <i className="fa fa-exclamation-circle error"></i>
                                        <div className="status-message">
                                            {error.msg}
                                        </div>
                                    </li>
                                )
                            }, this)}
                        </ul>
                    );
                } else {
                    errors = (
                        <div>
                            <i className="fa fa-exclamation-circle error"></i>
                            <div className="status-message">
                                This shortener has not been able to connect.
                            </div>
                        </div>
                    )
                }

                statusBlock = (
                    <div className="detail-status error">
                        {errors}
                    </div>
                );

            }

            if (!_.isEmpty(this.props.errors)) {
                if (this.props.errors.errors.validation && this.props.type === 'shortener') {
                    statusBlock = (
                        <div className="detail-status error">
                            We can't connect to your shortener right now.
                        </div>
                    );
                } else {
                    statusBlock = (
                        <div className="detail-status error">
                            We couldn't update your {thingLabel.toLowerCase()}. Check the errors and try again.
                        </div>
                    );
                }
            }

            if (this.props.detail.ssID) {
                switch (parseInt(this.props.detail.ssID, 10)) {
                    case constants.SHORTEN_SVC_BITLY:
                        Panel = ShortenerDetailBitly;
                        break;

                    case constants.SHORTEN_SVC_CUSTOM:
                        Panel = ShortenerDetailCustom;
                        break;

                    default:
                        Panel = ShortenerDetailDefault;
                }
            } else {
                if (parseInt(this.props.detail.id) === 0) {
                    // Synthetic "No Shortener" — falls in here because it carries no ssID.
                    Panel = ShortenerDetailDefault;
                } else {
                    Panel = ShortenerDetailDomain;
                }
            }

            panelContent = (
                <Panel
                    {...this.props}
                    errors={this.props.errors}
                    state='edit'
                    defaultPdId={this.props.defaultPdId}
                    defaultSaId={this.props.defaultSaId} />
            );

        }



        return (
            <div>
                {detailControls}
                {statusBlock}
                <div className="editor-panel">
                    {panelContent}
                </div>
            </div>
        );
    }

};

ShortenerListDetail.displayName = "ShortenerListDetail";

ShortenerListDetail.propTypes = {
    type: PropTypes.string,
    detail: PropTypes.object,
    deleteItem: PropTypes.func,
    updatedCreds: PropTypes.string,
    reauthHandler: PropTypes.func,
    errors: PropTypes.object,
    defaultPdId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    defaultSaId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

ShortenerListDetail.defaultProps = {
    type: '',
    detail: {},
    setAsDefault: null,
    apply: null,
    deleteItem: null,
    updatedCreds: '',
    reauthHandler: null,
    errors: null,
    defaultPdId: 0,
    defaultSaId: 0
};

export default ShortenerDetailWrapper(ShortenerListDetail);
